/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import { AppBar, MenuItem, Select, Toolbar, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { ko } from "date-fns/locale";
import moment from "moment";
import { useState } from "react";
import Swal from "sweetalert2";
import { configState } from "../lib/State";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onCloseAddPop } = props;
  const token = localStorage.getItem("token");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState("");
  const [tcid, setTcid] = useState(""); //1
  const [type, setType] = useState(""); //2
  const [tmcd, setTmcd] = useState(""); //3
  const [title, setTitle] = useState("적립"); //4
  const [point, setPoint] = useState(0); //5
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-DD"));

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/point_add",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        tmcd: tmcd,
        type: type,
        title: title,
        point: point,
        sdate: sdate,
      },
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onCloseAddPop();
        },
      );
    }
  };

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  return (
    <Box>
      {/* 사용자 팝업 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sName}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        {/* 포인트구분 */}
        <div className="mt-2">
          <select
            className="p-2"
            name="type"
            onChange={(e) => setType(e.target.value)}
          >
            <option>포인트구분</option>
            <option value="심박포인트">심박포인트</option>
            <option value="출석포인트">출석포인트</option>
            <option value="캐시">캐시</option>
            <option value="심박스탬프">심박스탬프</option>
          </select>
        </div>

        {/* 제목 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="title"
            label="제목"
            size="small"
            autoComplete="off"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ width: 260 }}
          ></TextField>
        </Box>

        {/* 포인트 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          {type === "심박스탬프" ? (
            <FormControl size="small" sx={{ width: 260 }}>
              <InputLabel id="point-select-label">포인트</InputLabel>
              <Select
                labelId="point-select-label"
                value={point}
                label="포인트"
                onChange={(e) => setPoint(e.target.value)}
              >
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </Select>
            </FormControl>
          ) : (
            <TextField
              name="point"
              label="포인트"
              size="small"
              autoComplete="off"
              value={point}
              onChange={(e) => setPoint(e.target.value)}
              sx={{ width: 260 }}
            ></TextField>
          )}
        </FormControl>

        {/* 적립일 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <MobileDatePicker
              allowSameDateSelection={true}
              value={sdate}
              autoOK
              label="지급일"
              renderInput={(params) => <TextField {...params} />}
              onChange={(newDate) =>
                setSdate(moment(newDate).format("YYYY-MM-DD"))
              }
              inputFormat={"yyyy.MM.dd"}
              autoComplete="off"
            />
          </LocalizationProvider>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onCloseAddPop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
